import FreeTrialBanner from '../subscriptions/FreeTrialBanner';
import StripeAccountBanner from '../stripe/StripeAccountBanner';
import ImpersonationBanner from '../global/ImpersonationBanner';
import BusinessWebRedesignBanner from './BusinessWebRedesignBanner';
import useBanners from '../../hooks/navigation/useBanners';

function Banners() {
  const {
    isBannerShown,
    isFreeTrialBannerShown,
    isStripeAccountBannerShown,
    isImpersonationBannerShown,
    isRedesignBannerShown,
  } = useBanners();

  if (!isBannerShown) return null;

  if (isImpersonationBannerShown) return <ImpersonationBanner />;
  if (isFreeTrialBannerShown) return <FreeTrialBanner />;
  if (isStripeAccountBannerShown) return <StripeAccountBanner />;
  if (isRedesignBannerShown) return <BusinessWebRedesignBanner />;

  return null;
}

export default Banners;
